import { AllPersonnelThemeSizeConfig } from './types';

const large: AllPersonnelThemeSizeConfig = {
  allPersonnel: {},
};

export default large;
